import { ModuleWithProviders, NgModule } from '@angular/core';
import { AppModule } from '@app/app.module';

@NgModule({})
export class ProfimaskeBaseModule {
  static forRoot(): ModuleWithProviders<ProfimaskeBaseModule> {
    return {
      ngModule: AppModule,
      providers: []
    }
  }
}